// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3h5lt","content":"Consent_content__B-3xK","footer":"Consent_footer__1yzqA"};